


















import Vue from 'vue'
import NewMonthList from '../molecules/NewMonthList.vue'
import NewMonthTitle from '../molecules/NewMonthTitle.vue'
import NoContentsMessage from '../molecules/NoContentsMessage.vue'

export default Vue.extend({
  components: {
    NewMonthList,
    NewMonthTitle,
    NoContentsMessage
  },
  props: {
    contents: {
      type: Object,
      required: true
    },
  },
  computed: {
    month(): number | null {
      return this.$store.state.month
    },
  }
})
